import React, { useEffect, useState } from 'react';
import { useTranslation } from '../contexts/LanguageContext';
import { useInstallPrompt } from '../hooks/useInstallPrompt';
import { useStandaloneMode } from '../hooks/useStandaloneMode';
import '../styles/components/InstallPrompt.css';

const ENGAGEMENT_DELAY_MS = 5000;

export default function InstallPrompt() {
  const { t } = useTranslation();
  const { isStandalone } = useStandaloneMode();
  const { canInstall, isIos, promptInstall, dismiss } = useInstallPrompt();
  const [delayed, setDelayed] = useState(false);

  useEffect(() => {
    const id = window.setTimeout(() => setDelayed(true), ENGAGEMENT_DELAY_MS);
    return () => window.clearTimeout(id);
  }, []);

  if (isStandalone || !canInstall || !delayed) return null;

  return (
    <div className="install-prompt" role="dialog" aria-label={t('install.title')}>
      <span className="install-prompt-icon" aria-hidden="true">{isIos ? '⎙' : '⬇'}</span>
      <div className="install-prompt-text">
        <strong>{t('install.title')}</strong>
        <span>{isIos ? t('install.iosBody') : t('install.androidBody')}</span>
      </div>
      {!isIos && (
        <button className="install-prompt-cta" onClick={promptInstall}>{t('install.cta')}</button>
      )}
      <button className="install-prompt-close" onClick={dismiss} aria-label={t('install.dismiss')}>×</button>
    </div>
  );
}
